import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  ApiContext,
  AUTH_CONFIG,
  AuthConfigurationProperties,
  BACKEND_CONFIG,
  PUSHMONKEY_CONFIG,
  REGISTRATION_CONFIG,
} from '@unicup-ticketing/injection-context';
import { environment } from './environments/environment';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { NAVIGATION_STATE } from '@unicup-ticketing/core';
import { IdmStateStore } from '@unicup-ticketing/service';

function initializeIcons(library: FaIconLibrary) {
  library.addIconPacks(fas);
}

const authConfig: AuthConfigurationProperties = {
  issuer: environment.auth.authority,
  redirectUri: environment.auth.redirectUri,
  clientId: environment.auth.clientId,
  scopes: [],
  verboseLogging: false,
};

const backendConfig: ApiContext = {
  baseUrl: environment.api.backendBaseUrl,
};

const pushMonkeyConfig: ApiContext = {
  baseUrl: environment.api.pushMonkeyBaseUrl,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    FontAwesomeModule,
    provideAppInitializer(() => initializeIcons(inject(FaIconLibrary))),
    IdmStateStore,

    {
      provide: NAVIGATION_STATE,
      useValue: { items: [] },
    },
    {
      provide: AUTH_CONFIG,
      useValue: authConfig,
    },
    {
      provide: BACKEND_CONFIG,
      useValue: backendConfig,
    },
    {
      provide: PUSHMONKEY_CONFIG,
      useValue: pushMonkeyConfig,
    },
    {
      provide: REGISTRATION_CONFIG,
      useValue: {
        showMembersVerifiedLabels: true,
      },
    },
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.api.backendBaseUrl, environment.api.pushMonkeyBaseUrl],
        sendAccessToken: true,
      },
    }),
  ],
};
